export const UPDATE = "alerts/UPDATE";
export const APPEND = "alerts/APPEND";
export const UPDATE_ONE = "alerts/UPDATE_ONE";
export const DESTROY = "alerts/DESTROY";
export const LOADING = "alerts/LOADING";
